import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import ReactPhoneInput from 'react-phone-input-2';

class EditStudentHost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lgShow: false,
      edit_host_page: {
        host_address: {
          type: "text",
          label: "Host's Address *",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host's Address",
          validations: { required: true },
        },
        host_id: {
          type: "text",
          label: "Host id",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host id",
          validations: { required: false },
        },
        host_name: {
          type: "text",
          label: "Host Name *",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host Name",
          validations: { required: true },
        },
        host_uuid: {
          type: "text",
          label: "Host uuid",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host uuid",
          validations: { required: false },
        },
        host_relation: {
          type: "text",
          label: "Host Relation *",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host Relation",
          validations: { required: true },
        },
        host_status: {
          type: "hidden",
          label: "Status",
          value: "false",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          validations: { required: false },
        },
        is_host_approved: {
          type: "checkbox",
          label: "Automatically approved as Host",
          value: "false",
          valid: true,
          error_msg: "",
          validations: { required: false },
        },
        student_host_comment: {
          type: "text",
          label: "Student Host Comment",
          value: "",
          valid: true,
          error_msg: "",
          validations: { required: false },
        },
        student_host_id: {
          type: "text",
          label: "Student Host Id",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Student Host Id",
          validations: { required: false },
        },
        host_email: {
          type: "email",
          label: "Host's Email *",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host's Email",
          validations: { required: true, email: true },
        },
        host_contact: {
          type: "text",
          label: "Host's Mobile Number *",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Host's Mobile Number",
          validations: { required: true },
        },
        student_first_name: {
          type: "text",
          label: "Student Name",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Student First Name",
          validations: { required: false },
        },
        student_last_name: {
          type: "text",
          label: "Student Name",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "Student last Name",
          validations: { required: false },
        },
        student_id: {
          type: "text",
          label: "Host id",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "student id",
          validations: { required: false },
        },
        student_uuid: {
          type: "text",
          label: "student uuid",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "student uuid",
          validations: { required: false },
        },
        unique_pin: {
          type: "text",
          label: "uniq pin",
          value: "",
          valid: true,
          error_msg: "",
          onBlur_out: false,
          placeholder: "uniq pin",
          validations: { required: false },
        },
      }
    };
  }
  componentDidMount() {
    {console.log(this.props.item ,"this.props.itemthis.props.item")}

    const updatedForm = { ...this.state.edit_host_page };
    const data = this.props.item;

    for (let key in updatedForm) {
      if (data[key] !== undefined) {
        updatedForm[key].value = String(data[key]);
      }
    }

    this.setState({ edit_host_page: updatedForm, lgShow: this.props.show_edit_host_moadal });
  }

  closeModal = () => {
    this.props.hideAddHostModal(false);
  };

  inputChangeHandler(e, key) {
    const updatedForm = { ...this.state.edit_host_page };
    updatedForm[key].value = e.target.value;
    this.setState({ edit_host_page: updatedForm });
  }

  inputPhoneHandler = (value, key) => {
    const updatedForm = { ...this.state.edit_host_page };
    updatedForm[key].value = value;
    this.setState({ edit_host_page: updatedForm });
  };

  toggleHostStatus = () => {
    const updatedForm = { ...this.state.edit_host_page };
    updatedForm.host_status.value = updatedForm.host_status.value === "true" ? "false" : "true";
    this.setState({ edit_host_page: updatedForm });
  };

  toggleHostApproval = () => {
    const updatedForm = { ...this.state.edit_host_page };
    updatedForm.is_host_approved.value = updatedForm.is_host_approved.value === "true" ? "false" : "true";
    this.setState({ edit_host_page: updatedForm });
  };

  SubmitHandlerHost = (e) => {
    e.preventDefault();
    const formData = {};
    const fields = this.state.edit_host_page;

    const hostPayload = {
      host_id: fields.host_id.value,
      host_name: fields.host_name.value,
      host_email: fields.host_email.value,
      host_relation: fields.host_relation.value,
      host_contact: fields.host_contact.value,
      host_address: fields.host_address.value,
      is_host_approved: fields.is_host_approved.value === "true",
      host_status: fields.host_status.value === "true",
      student_host_comment: fields.student_host_comment.value,
      student_name: fields.student_first_name.value + " " + fields.student_last_name.value,
    };

    formData['student_id'] = fields.student_id.value;
    formData['host_data'] = JSON.stringify([hostPayload]);

    this.props.AddOrUpdateStudentHost(formData);
  };

  render() {
    const { edit_host_page } = this.state;

    return (
      <>
        <Modal size="lg" show={this.state.lgShow} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Host</Modal.Title>
          </Modal.Header>
          <form onSubmit={this.SubmitHandlerHost}>
            <Modal.Body className="show-grid">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <label>{edit_host_page.student_first_name.label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={`${edit_host_page.student_first_name.value} ${edit_host_page.student_last_name.value}`}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label>{edit_host_page.host_name.label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={edit_host_page.host_name.value}
                    onChange={(e) => this.inputChangeHandler(e, "host_name")}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label>{edit_host_page.host_email.label}</label>
                  <input
                    type="email"
                    className="form-control"
                    value={edit_host_page.host_email.value}
                    onChange={(e) => this.inputChangeHandler(e, "host_email")}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label>{edit_host_page.host_contact.label}</label>
                  <ReactPhoneInput
                    countryCodeEditable={false}
                    value={edit_host_page.host_contact.value}
                    onChange={(value) => this.inputPhoneHandler(value, "host_contact")}
                    enableLongNumbers
                    autoComplete="off"
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label>{edit_host_page.host_relation.label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={edit_host_page.host_relation.value}
                    onChange={(e) => this.inputChangeHandler(e, "host_relation")}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <label>{edit_host_page.host_address.label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={edit_host_page.host_address.value}
                    onChange={(e) => this.inputChangeHandler(e, "host_address")}
                  />
                </div>
                <div className="mb-4">
                  <label>{edit_host_page.student_host_comment.label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={edit_host_page.student_host_comment.value}
                    onChange={(e) => this.inputChangeHandler(e, "student_host_comment")}
                  />
                </div>

                {/* Toggleable badges */}
                <div className="mb-0 row">
                  <div className="col-12 mb-3">
                    <label>{edit_host_page.host_status.label}</label>
                    <span
                      className={`badge px-4 py-2 ${edit_host_page.host_status.value === "true" ? "bg-success" : "bg-danger"}`}
                      style={{ cursor: "pointer", marginLeft: "20px" }}
                      onClick={this.toggleHostStatus}
                    >
                      {edit_host_page.host_status.value === "true" ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <div className="col-12">
                    <label>{edit_host_page.is_host_approved.label}</label>
                    <span className='ms-5'>
                      {edit_host_page.is_host_approved.value ? (
                        <h1 className="badge badge-light-success px-4 py-2">Approved</h1>
                      ) : (
                        <h1 className="badge badge-light-danger px-4 py-2">Unapproved</h1>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-secondary btn-sm" onClick={this.closeModal}>
                Close
              </button>
              <button className="btn btn-primary btn-sm" type="submit">
                Save Changes
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      </>
    );
  }
}

export default EditStudentHost;
